import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/hair-loss-blog/tag/$slug")({
  beforeLoad: ({ params }) => {
    throw redirect({ href: `/tag/${params.slug}/`, statusCode: 301 });
  },
});
